/**
 * Route for `affiliate-referral-program-builder`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateReferralProgramBuilderPage } from "../features/affiliate-referral-program-builder/AffiliateReferralProgramBuilderPage";

export const affiliateReferralProgramBuilderRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-referral-program-builder",
	component: AffiliateReferralProgramBuilderPage,
});

export default affiliateReferralProgramBuilderRoute;
